
   
    <!-- Default box -->
    <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Bike Rent Data List</div> 
        <div class="row mt-2 ml-3">
           <div class="input-group col-md-8 ">         
                  
            <mat-form-field class="example-form-field">
              <mat-label  [ngClass]="{'dark-bg' : isDark }">Search</mat-label>  
              <span matPrefix><i class="fas fa-search">&nbsp; &nbsp;</i></span>                    
              <input  matInput type="text" autocomplete="off" [(ngModel)]="searchKey" (keyup)="applyFilter()">
              <span class="input-group-append" matSuffix>
                <button class="btn  border-0" type="button">
                    <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close"  [ngClass]="{'dark-bg' : isDark }"></i>
                </button>
              </span> 
            </mat-form-field>
  
          </div>
          <div class="col-md-4">
            <button *ngIf="crud_access.create"  (click)="newCustomerButtonClick()" class="btn btn-success float-right mr-4"><i class="fa fa-plus p-1"></i>New</button>
          </div>      
        </div>
        <form class="form-horizontal">
        <fieldset>
        <div class="card-body">
  
          <div>
            <mat-table [dataSource]="dataSource" matSort>
                                
              <ng-container matColumnDef="RentId">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> RentId </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.RentId}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="PersonName">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> PersonName </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.PersonName}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="VehicleNo">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }">VehicleNo </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.VehicleNo}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Brand">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }">Brand </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.Brand}} </mat-cell>
              </ng-container>
  
                      
              <ng-container matColumnDef="DateStart">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> DateStart </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.DateStart | date :'y-MM-dd'}} </mat-cell>
              </ng-container>
                     
  
              <ng-container matColumnDef="DateFinish">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> DateFinish </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.DateFinish | date :'y-MM-dd'}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="TotalMiles">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> TotalMiles </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.TotalMiles}} </mat-cell>
              </ng-container>


              <ng-container matColumnDef="CreatedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
                <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
              </ng-container>
  
  
              <ng-container matColumnDef="Action">
                <mat-header-cell *matHeaderCellDef  [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
                <mat-cell *matCellDef="let row"  [ngClass]="{'dark-bg' : isDark }">
                  <button *ngIf="crud_access.read"  class="btn btn-primary btn-sm text-white" (click)="gerRowData(row)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="far fa-folder-open"></i></button>
                    <button *ngIf="crud_access.delete"  class="btn btn-danger btn-sm ml-1 text-white"  (click)="deleteButtonClick(row.RentId)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>        
                </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
              </ng-container>
  
              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="6"  [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
              </ng-container>
            
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
            </mat-table>
  
            <mat-paginator  [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  
            </div>
  
  
        </div>                                
        <!-- /.card-body -->
  
      </fieldset>
        </form>
      </div>
  
    
  <script>
  
    $(function () {
    $('[data-toggle="viewTooltip"]').tooltip()
  })
  $(function () {
    $('[data-toggle="deleteTooltip"]').tooltip()
  })
  </script>
  
